import { BikePedalIcon } from './BikePedalIcon';

/**
 * author: Jeff Anders
 * id 31FF4583-E8CF-45E3-9F21-F75022605846
 * name bike-pedal
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bike-pedal.svg
 * tags
 * - Transportation + Other 
 * - Sport 
 */
export const BikePedalFlatIcon = BikePedalIcon;
export default BikePedalFlatIcon